import { Card, Row } from 'antd';
import React from 'react'
import Heading from '../../../component/common/Heading';
import CRUDComponent from '../../../component/common/CRUD-Component';
import CONSTANTS from '../../../util/constant/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { convertUTCToLocal } from '../../../util/functions';

const RoleAndAccess = () => {
    return (
        <>
            <div>
                <Card className="my-5">
                    <Heading>Access List</Heading>
                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.Role_Access.getAll,
                                DataModifier: (res, API, Setrefresh) => {
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `R${data?.id.toString().padStart(7, "0")}`,
                                            date: convertUTCToLocal(data?.createdAt, 'DD MMM YYYY hh:mm A'),
                                            block: {
                                                checked: !data?.isBlock,
                                                id: data?.id,
                                                onClick: (id, val) => {
                                                    const UpdateAPIEnd = { ...CONSTANTS?.API.Role_Access.update };
                                                    UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                                                    API.sendRequest(
                                                        UpdateAPIEnd,
                                                        () => {
                                                            Setrefresh((prev) => !prev);
                                                        },
                                                        { isBlock: val },
                                                        `Role ${val ? "Blocked" : "Unblock"} Successfully`
                                                    );
                                                },

                                            },

                                        }
                                    });
                                },
                                column: CONSTANTS.TABLE.ROLE_AND_ACCESS,
                            }}
                            isSearch
                            UPDATE={{
                                API: CONSTANTS.API.Role_Access.update,
                                message: "Edit Role successfully",
                                modaltitle: "Edit Role",
                                modalFields: CONSTANTS.FORM_FIELD.EDIT_ROLE_ACCESS_MODAL,
                                // payloadModifier: (res) => res,
                            }}
                            CREATE={{
                                API: CONSTANTS.API.Role_Access.add,
                                message: "Created Role successfully",
                                modaltitle: "Add Role",
                                modalFields: CONSTANTS.FORM_FIELD.ROLE_ACCESS_MODAL,
                                // payloadModifier: (res) => res,
                            }}
                            DELETE={{
                                API: CONSTANTS.API.Role_Access.delete,
                                message: "Deleted Role Successfully",
                            }}
                        />
                    </Row>
                </Card>

            </div>


        </>
    )
}

export default RoleAndAccess